module.exports = __webpack_public_path__ + "static/img/store2.951fbb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store2.png
// module id = TL2Y
// module chunks = 1